<template>
<div v-if="calls.length">
  <div class="card-body">
    <h5 class="card-title d-none d-lg-block">Klici <small class="text-muted">{{ calls.length }}</small></h5>
    <ul class="list-unstyled mb-0">
      <li v-for="c in calls" :key="c.ID" class="mb-2">
        <router-link :to="{ name: 'CallEdit', params: { callId: c.ID } }" target="_blank"
          class="link-dark" title="Odpri klic v novem zavihku">
          <strong>{{ callTimeText(c) }}</strong>
        </router-link>
        <div class="small text-muted">{{ callerText(c) }}</div>
      </li>
    </ul>
  </div>
</div>
</template>

<script setup>
import { ref, watch, onMounted } from "vue"
import dayjs from "dayjs"
import { useAuth } from "../composition-api/useAuth"
import { listEntitiesAsync } from "../api"
import { EMPTY_GUID, DATETIME_FORMAT_DISPLAY } from "../utils/constants"

// The calls that ended up on this SDN. The operator links a call to an existing SDN from the
// "Klici" list (outcome "Obstoječi SDN"), so the order can show who called about it, when, and
// what was said - the link opens the call itself in a new tab. Renders nothing while the SDN
// has no calls, so it does not put an empty card on every order.

defineOptions({ name: "ServiceOrderCallsCard" })

const props = defineProps({
    serviceOrderId: {
      type: String,
      default: EMPTY_GUID,
    },
  })

const { fetchAuthAsync } = useAuth()

const calls = ref([])

// the call as it was made - CallStart is only filled once the call was answered, so fall
// back to when the row was created
const callTimeText = (c) => dayjs(c.CallStart || c.DateCreated).format(DATETIME_FORMAT_DISPLAY)

// name the operator wrote down, next to the number where there is one
const callerText = (c) => {
  const name = (c.CallerName || "").trim()
  const number = (c.CallerNumber || "").trim()
  if (name && number) return `${name} - ${number}`
  return name || number || "Neznan klicatelj"
}

const loadAsync = async () => {
  // the calls the operator linked to this SDN (they live in dbo.Calls.ServiceOrderID)
  calls.value = (await listEntitiesAsync(fetchAuthAsync, `Calls/List/ServiceOrder/${props.serviceOrderId}`)) ?? []
}

watch(
  () => props.serviceOrderId,
  () => loadAsync(),
)

onMounted(loadAsync)
</script>
